// src/firebase/config.js
// =====================================================
// STEP 1: Go to https://console.firebase.google.com
// STEP 2: Create a project → Add Web App
// STEP 3: Enable Authentication (Email/Password + Google)
// STEP 4: Enable Firestore Database
// STEP 5: Enable Storage
// STEP 6: Replace the config below with your credentials
// =====================================================

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCFquLMi_RXG6jlGvk2nh2h8fw6fTfCafU',
    authDomain: "the-shop-world.firebaseapp.com",
    projectId: "the-shop-world",
    storageBucket: "the-shop-world.appspot.com",
    messagingSenderId: "586975506868",
    appId: "1:586975506868:web:abcd1234efgh5678"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
